import axios from "axios"

const liveApiUrl = process.env.REACT_APP_LIVE_API_URL

export const getTransportReport = async payload => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("Token"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `https://marcopolo.prisms.in/api/QR/attendance/transportAttend`,
      payload,
      { headers }
    )
    return response
  } catch (error) {
    console.error("[API] Error Gettting Time Table:", error)
    throw error
  }
}